const removeImages = (content) => {
    // Expressão regular para encontrar tags de imagem
    const imgRegex = /<img[^>]+>/g;

    // Substituir as tags de imagem por uma string vazia
    return content.replace(imgRegex, '');
  };

  export default removeImages;

